import React, { useEffect, useState } from "react";

interface ThirdPartyAdSpaceProps {
  urls: string[];
  aspectRatio: string;
}

function ThirdPartyAdSpace({ urls, aspectRatio }: ThirdPartyAdSpaceProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (urls.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % urls.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [urls.length]);

  const parseResolution = (res: string) => {
    if (!res) return { height: undefined };
    const [, h] = res.split("x").map(Number);
    return { height: h };
  };

  const containerStyle: React.CSSProperties = {
    position: "relative",
    height: parseResolution(aspectRatio).height,
    overflow: "hidden",
    margin: "auto",
  };

  const slideStyle = (url: string, index: number): React.CSSProperties => ({
    position: index === 0 ? "relative" : "absolute",
    inset: 0,
    backgroundImage: `url(${url})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
    opacity: index === currentIndex ? 1 : 0,
    transition: "opacity 0.6s ease-in-out",
  });

  if (!urls.length) return null;

  return (
    <div style={containerStyle}>
      {urls.map((url, i) => (
        <div key={i} style={slideStyle(url, i)} />
      ))}
    </div>
  );
}

export default ThirdPartyAdSpace;
